module.exports = __webpack_public_path__ + "static/media/item03.e5e39871.png";